import React, { useState, useEffect, useMemo } from 'react';
import DatePicker from 'react-datepicker';
import Slider from 'rc-slider';
import { getFirestore, doc, updateDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-slider/assets/index.css';
import '../Pages/Reservation.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import appFirebase from '../Firebase/Firebase';

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const ReservationForm = ({
    selectedSpace,
    selectedDate,
    setSelectedDate,
    selectedStartTime,
    selectedEndTime,
    handleSliderChange,
    handleReserve,
    reservations,
    userCoins,
    userId,
    costPerInterval = 5 // Costo por intervalo de media hora
  }) => {
    const [occupiedIntervals, setOccupiedIntervals] = useState([]);
    const [cost, setCost] = useState(0);
  
    useEffect(() => {
      if (selectedDate && selectedSpace) {
        try {
          const selectedDateStart = new Date(selectedDate);
          selectedDateStart.setHours(0, 0, 0, 0);
          const selectedDateEnd = new Date(selectedDate);
          selectedDateEnd.setHours(23, 59, 59, 999);
  
          const intervals = reservations
            .filter(reservation =>
              reservation.spaceId === selectedSpace.id &&
              reservation.start.toDate() >= selectedDateStart &&
              reservation.end.toDate() <= selectedDateEnd
            )
            .map(reservation => {
              const start = reservation.start.toDate();
              const end = reservation.end.toDate();
              return {
                start: (start.getHours() * 2) + (start.getMinutes() / 30),
                end: (end.getHours() * 2) + (end.getMinutes() / 30)
              };
            });
          setOccupiedIntervals(intervals);
        } catch (error) {
          console.error('Error processing reservations:', error);
        }
      } else {
        setOccupiedIntervals([]);
      }
    }, [selectedDate, selectedSpace, reservations]);
  
    useEffect(() => {
      if (selectedStartTime && selectedEndTime) {
        const startHours = selectedStartTime.getHours();
        const startMinutes = selectedStartTime.getMinutes();
        const endHours = selectedEndTime.getHours();
        const endMinutes = selectedEndTime.getMinutes();
  
        const start = (startHours * 2) + (startMinutes / 30);
        const end = (endHours * 2) + (endMinutes / 30);
        const duration = end - start;
  
        setCost(duration * costPerInterval);
      } else {
        setCost(0);
      }
    }, [selectedStartTime, selectedEndTime, costPerInterval]);
  
    const generateRailStyle = useMemo(() => {
      const railStyle = Array(48).fill({ backgroundColor: 'lightgray' });
      occupiedIntervals.forEach(interval => {
        for (let i = interval.start; i < interval.end; i++) {
          railStyle[i] = { backgroundColor: 'red' };
        }
      });
      return railStyle;
    }, [occupiedIntervals]);
  
    const handleReserveClick = async () => {
      if (!userId) {
        toast.error("El ID de usuario no está definido");
        return;
      }
  
      if (cost > userCoins) {
        toast.error("No tienes suficientes coins para hacer esta reserva.");
        return;
      }
  
      try {
        const userDocRef = doc(db, 'usuarios', userId);
        const userDoc = await getDoc(userDocRef);
  
        if (!userDoc.exists()) {
          toast.error("No se pudo encontrar el documento del usuario.");
          return;
        }
  
        const userData = userDoc.data();
        const currentCoins = userData.coins || 0;
        if (currentCoins < cost) {
          toast.error("No tienes suficientes coins para hacer esta reserva.");
          return;
        }
  
        await handleReserve();
  
        await updateDoc(userDocRef, { coins: currentCoins - cost });
        toast.success("Reserva confirmada y coins actualizadas.");
      } catch (error) {
        console.error('Error al procesar la reserva:', error);
        toast.error("Hubo un error al procesar la reserva.");

      }
    };
  
    return (
      <div className="reservation-section">
         <ToastContainer />

        <h1 className="reservation-h1">Reservar</h1>
        {selectedSpace ? (
          <div className='reservation-form'>
            <h2 className="reservation-h2">Espacio Seleccionado:</h2>
            <p><strong>{selectedSpace.nombreEspacio}</strong></p>
            <p>Tipo: {selectedSpace.tipo}</p>
            <p>Máximo de Personas: {selectedSpace.maxPersonas}</p>
            <div>
              <h3>Selecciona una fecha:</h3>
              <DatePicker
                selected={selectedDate}
                onChange={date => setSelectedDate(date)}
                dateFormat="yyyy/MM/dd"
              />
            </div>
            {selectedDate && (
              <div className='reservation-slider-container'>
                <h3>Selecciona el intervalo de tiempo:</h3>
                <br />
                <div className='reservation-slider'>
                  <Slider
                    range
                    min={0}
                    max={48}
                    step={1}
                    marks={{
                      0: '00:00',
                      12: '06:00',
                      24: '12:00',
                      36: '18:00',
                      48: '24:00'
                    }}
                    onChange={handleSliderChange}
                    value={[
                      (selectedStartTime ? (selectedStartTime.getHours() * 2) + (selectedStartTime.getMinutes() / 30) : 0),
                      (selectedEndTime ? (selectedEndTime.getHours() * 2) + (selectedEndTime.getMinutes() / 30) : 0)
                    ]}
                    trackStyle={[{ backgroundColor: 'blue' }]}
                    railStyle={{ background: `linear-gradient(to right, ${generateRailStyle.map(style => style.backgroundColor).join(', ')})` }}
                    handleStyle={[
                      { borderColor: 'blue' },
                      { borderColor: 'blue' }
                    ]}
                  />
                </div>
                <div>
                  {selectedStartTime && selectedEndTime && (
                    <p>
                      Hora de inicio: {selectedStartTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
                      Hora de fin: {selectedEndTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
                      Costo: {cost} coins
                    </p>
                  )}
                </div>
              </div>
            )}
            <button
              className="reservation-confirmar"
              onClick={handleReserveClick}
              disabled={cost > userCoins}
            >
              Confirmar Reserva
            </button>
          </div>
        ) : (
          <p>No se ha seleccionado ningún espacio.</p>
        )}
      </div>
    );
  };
  
  export default ReservationForm;
  